module.exports = __webpack_public_path__ + "images/123_1024.jpg";